module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_8004.7ddc1e07.png";